import { FC } from "react"
import { useFormikContext } from "formik"

import { ThemeEnum } from "domain/customization/types"

import { InputField } from "view/components/formik/InputField"

import * as S from "./styled"
import { MainWidgetPage } from "../MainWidgetPage"
import { CardFormWidgetPage } from "../CardFormWidgetPage"

type TThemeFormProps = {
  theme: ThemeEnum
}

export const ThemeForm: FC<TThemeFormProps> = ({ theme }) => {
  const { values, isSubmitting } = useFormikContext()

  return (
    <S.Wrapp>
      <S.ThemePalette $theme={theme}>
        <div>
          <S.FieldLabel>Primary Background</S.FieldLabel>
          <S.FieldValueWrapp>
            <S.FieldColor $color={values[theme].primaryBackground} />
            <S.FieldInpWrapp>
              <InputField
                name={`${theme}.primaryBackground`}
                cleanable={false}
                disabled={isSubmitting}
                isTooltipText
              />
            </S.FieldInpWrapp>
          </S.FieldValueWrapp>
        </div>

        <div>
          <S.FieldLabel>Secondary Background</S.FieldLabel>
          <S.FieldValueWrapp>
            <S.FieldColor $color={values[theme].secondaryBackground} />
            <S.FieldInpWrapp>
              <InputField
                name={`${theme}.secondaryBackground`}
                cleanable={false}
                disabled={isSubmitting}
                isTooltipText
              />
            </S.FieldInpWrapp>
          </S.FieldValueWrapp>
        </div>

        <div>
          <S.FieldLabel>Primary Color</S.FieldLabel>
          <S.FieldValueWrapp>
            <S.FieldColor $color={values[theme].primaryColor} />
            <S.FieldInpWrapp>
              <InputField
                name={`${theme}.primaryColor`}
                cleanable={false}
                disabled={isSubmitting}
                isTooltipText
              />
            </S.FieldInpWrapp>
          </S.FieldValueWrapp>
        </div>

        <div>
          <S.FieldLabel>Secondary Color</S.FieldLabel>
          <S.FieldValueWrapp>
            <S.FieldColor $color={values[theme].secondaryColor} />
            <S.FieldInpWrapp>
              <InputField
                name={`${theme}.secondaryColor`}
                cleanable={false}
                disabled={isSubmitting}
                isTooltipText
              />
            </S.FieldInpWrapp>
          </S.FieldValueWrapp>
        </div>

        <div>
          <S.FieldLabel>Primary Text Color</S.FieldLabel>
          <S.FieldValueWrapp>
            <S.FieldColor $color={values[theme].primaryTextColor} />
            <S.FieldInpWrapp>
              <InputField
                name={`${theme}.primaryTextColor`}
                cleanable={false}
                disabled={isSubmitting}
                isTooltipText
              />
            </S.FieldInpWrapp>
          </S.FieldValueWrapp>
        </div>
      </S.ThemePalette>

      <S.WidgetPages>
        <MainWidgetPage config={values[theme]} theme={theme} />
        <CardFormWidgetPage config={values[theme]} theme={theme} />
      </S.WidgetPages>
    </S.Wrapp>
  )
}
